import { render, staticRenderFns } from "./ReportsManagement.vue?vue&type=template&id=294b4738&scoped=true&"
import script from "./ReportsManagement.vue?vue&type=script&lang=js&"
export * from "./ReportsManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReportsManagement.vue?vue&type=style&index=0&id=294b4738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b4738",
  null
  
)

export default component.exports